import { Injectable, Injector } from '@angular/core';
import { MapToServerSideEnum } from 'src/core/decorators/enum/mapto-server-side-enum.decorator';
import { ServerSideEnum } from './server-side-enum.model';

@Injectable({
  providedIn: 'root',
})
@MapToServerSideEnum('CategoryDiscoveryOption')
export class CategoryDiscoveryOption extends ServerSideEnum {
  DialoguesAndCategories: number;
  OnlyDialogues: number;
  OnlyCategories: number;

  constructor(injector: Injector) {
    super(injector);
  }
}
